import _objectWithoutProperties from "/Users/oct16/work/Cat/timecat-issue-helper/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default (function (_ref) {
  var components = _ref.components,
      props = _objectWithoutProperties(_ref, ["components"]);

  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "\u8BF7\u5C3D\u53EF\u80FD\u8BE6\u5C3D\u5730\u8BF4\u660E\u8FD9\u4E2A\u9700\u6C42\u7684\u7528\u4F8B\u548C\u573A\u666F\u3002\u6700\u91CD\u8981\u7684\u662F\uFF1A\u89E3\u91CA\u6E05\u695A\u662F\u600E\u6837\u7684", /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "p"
  }, "\u7528\u6237\u4F53\u9A8C\u9700\u6C42"), "\u50AC\u751F\u4E86\u8FD9\u4E2A\u529F\u80FD\u4E0A\u7684\u9700\u6C42\u3002"));
});